export const faqGroups = [
  {
    title: "Getting started",
    items: [
      {
        question: "What is Allading?",
        answer:
          "Allading is a messaging app for direct and group conversations, text messages, photos, voice notes, and voice and video calls. It offers secure chats for end-to-end encrypted conversations and ordinary chats for cloud history.",
      },
      {
        question: "How do I create an Allading account?",
        answer:
          "Register with your email address and a password, verify your email with the code you receive, and complete your profile. You can then find people and send contact requests.",
      },
      {
        question: "How do I add someone to my contacts?",
        answer:
          "Find a person in the app and send a contact request. Incoming requests can be reviewed before you accept them and add the person to your contacts.",
      },
      {
        question: "Where can I download Allading?",
        answer:
          "Use the Google Play link in the download section of this page. An App Store download link will be added when it is available; this page currently does not provide an iOS store link.",
      },
    ],
  },
  {
    title: "Chats & messages",
    items: [
      {
        question: "What can I send in an Allading chat?",
        answer:
          "You can send text messages, photos and recorded voice notes. Conversations also support replies and reactions, and keep call summaries alongside your messages.",
      },
      {
        question: "Does Allading support group chats?",
        answer:
          "Yes. Allading supports direct conversations and group chats. Group conversations use ordinary chat mode with cloud history and server-managed encryption; they are not end-to-end encrypted.",
      },
      {
        question: "Can I edit or delete a message?",
        answer:
          "You can edit your own text messages and delete your own messages. Edited text is marked as edited. Deleted messages leave a deletion marker in the conversation. Photos, voice notes and call summaries cannot be edited as text.",
      },
      {
        question: "How do I find unread messages and conversations?",
        answer:
          "The chat list provides search, unread indicators and group filters. Message previews help you identify a conversation before opening it. Opening a chat updates its read state.",
      },
      {
        question: "What happens to messages when my connection drops?",
        answer:
          "The app can keep pending outgoing messages in a local outbox and retry when connectivity returns. Queued does not mean delivered: delivery still depends on a working connection and the message being accepted. The queue has capacity limits, and unsuccessful messages may need your attention.",
      },
    ],
  },
  {
    title: "Calls & connection",
    items: [
      {
        question: "Can I make voice and video calls?",
        answer:
          "Yes. Start a voice or video call from a conversation. During a call, you can mute your microphone, control audio output and manage video. Calls require internet connectivity and the relevant microphone or camera permissions.",
      },
      {
        question: "Can I share my screen during a call?",
        answer:
          "Allading includes screen sharing during calls on supported devices. Start sharing from the call controls and approve the system capture prompt. Availability depends on your platform and device permissions.",
      },
      {
        question: "Why does an incoming call appear as a notification?",
        answer:
          "Incoming call presentation depends on system permissions and device setup. On Android, Settings shows incoming-call readiness and lets you repeat setup. When system call integration is not ready, the app uses a notification fallback.",
      },
      {
        question: "Will I see the outcome of a call in my chat?",
        answer:
          "Call summaries appear in the conversation so you can review the call outcome and, for connected calls, its duration.",
      },
      {
        question: "Does Allading work without the internet?",
        answer:
          "Cloud connectivity is the primary transport for messaging and calls. Pending messages can retry after reconnection. Android Bluetooth and Wi-Fi mesh tools are available for diagnostics and do not provide a guaranteed offline messaging or calling service.",
      },
    ],
  },
  {
    title: "Privacy & chat modes",
    items: [
      {
        question: "What is the difference between secure and ordinary chats?",
        answer:
          "Secure chats use the Signal Protocol for end-to-end encryption and device-based conversations; the server relays encrypted content with limited retention. Ordinary chats keep cloud history using server-managed encryption so it can be loaded after signing in on another device. Ordinary chats are not end-to-end encrypted.",
      },
      {
        question: "Are all Allading messages end-to-end encrypted?",
        answer:
          "No. End-to-end encryption applies to secure chats. Ordinary chats and group chats use server-managed encryption. Choose the chat mode with this difference in mind.",
      },
      {
        question: "How can I verify a secure chat with my contact?",
        answer:
          "Compare the safety numbers or scan the verification QR code with your contact through a channel you trust. This helps you check that the secure conversation uses the expected identity keys.",
      },
      {
        question: "Can I restore every conversation on a new phone?",
        answer:
          "Ordinary chat history can be loaded from the cloud after signing in. Secure chats are device-based and should not be treated as a cloud history archive. Restoring encryption keys is a separate process from restoring message history.",
      },
    ],
  },
  {
    title: "Backup & troubleshooting",
    items: [
      {
        question: "What does the PIN-protected backup save?",
        answer:
          "The encrypted backup protects your encryption keys. Enable it in Settings and keep the PIN safe for key restoration. A key backup is not a complete backup of every message, photo or voice note.",
      },
      {
        question: "Where can I manage privacy, backup and call permissions?",
        answer:
          "Open Settings to manage encrypted key backup, review privacy and security information, and check incoming-call setup on Android. System microphone, camera and notification permissions are managed through your device settings.",
      },
      {
        question: "What should I check if a message or call does not work?",
        answer:
          "Check your internet connection first. For calls, also check microphone, camera and notification permissions and incoming-call readiness on Android. Review pending message status before retrying. If the issue continues, contact support with the steps that led to it, without sharing passwords, verification codes or your backup PIN.",
      },
    ],
  },
];
